module.exports = __webpack_public_path__ + "static/media/silver.e7ff3497.svg";